export const activitiesData = [
    // ------------------ 1 ------------------
    {
        id: 1,
        activity_name: "Admit Card Issue — Batch 1",
        auto_generated: "EVENT#1",
        descriptions: "Admit card generates",
        timeline: { start: "2025-02-02", end: "2025-02-06" },
        status: "active",
        assigned_to: ["Amit"],
        students_summary: { noc_cleared: "6/10", admit_issued: "7/10" },
        prechecks_summary: { pending: 10, success: 10, total: 20 },
        admit_status_count: { total: 10, success: 4, pending: 6 },
        details: {
            timeline: "2/2/2025 — 2/6/2025",
            assigned_employees: ["Amit"],
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            dues_summary: { pending: 3, done: 7 ,total:10},
            nocs_summary: { pending: 5, done: 5,total:10 },
            selected_students: [
                { roll_no: "R101", name: "Student 1", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION C", student_registration_number: "BITE/BA/01",due_pending:false,otp_verified:true,bio_metric:true },
                { roll_no: "R102", name: "Student 2", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false ,otp_verified:false,bio_metric:true},
                { roll_no: "R103", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit  Card Not Issued", course: "B.CA Semester 1 - SECTION C", student_registration_number: "BITE/BCA/03" ,due_pending:false,otp_verified:true,bio_metric:false},
                { roll_no: "R104", name: "Student 4", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Com Semester 1 - SECTION C", student_registration_number: "BITE/BCOM/04" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R105", name: "Student 5", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION C", student_registration_number: "BITE/BA/05" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R106", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION C", student_registration_number: "BITE/BSC/06" ,due_pending:true,otp_verified:true,bio_metric:true},
                { roll_no: "R107", name: "Student 7", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.CA Semester 1 - SECTION C", student_registration_number: "BITE/BCA/07" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R108", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit  Card Not Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08" ,due_pending:true},
                { roll_no: "R109", name: "Student 9", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION B", student_registration_number: "BITE/BA/09" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R110", name: "Student 10", primary_status: "NOC Pending", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10",due_pending:true,otp_verified:true,bio_metric:true }
            ]
        }
    },

    // ------------------ 2 ------------------
    {
        id: 2,
        activity_name: "Event Participation — Batch 1",
        auto_generated: "EVENT#2",
        descriptions: "Event Participation card generates",
        timeline: { start: "2025-03-03", end: "2025-03-07" },
        status: "closed",
        assigned_to: ["Amit"],
        admit_status_count: { total: 20, success: 16, pending: 4 },
        students_summary: [
            { key: "registered", value: "7/10" },
            { key: "approved", value: "5/10" }
        ],

        details: {
            timeline: "3/3/2025 — 3/7/2025",
            assigned_employees: ["Amit"],
            dues_summary: { pending: 4, done: 8,total :12 },
            nocs_summary: { pending: 5, done: 7 ,total:12},
            prechecks_summary: { pending: 10, success: 10, total: 20 },

            selected_students: [
                { roll_no: "R201", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A  Semester 1 - SECTION A", student_registration_number: "BITE/BA/01",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R202", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc  Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R203", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA  Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03",due_pending:true ,otp_verified:true,bio_metric:true},
                { roll_no: "R204", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit  Card Not Issued", course: "B.Com  Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R205", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit Card Issued", course: "B.A  Semester 1 - SECTION A", student_registration_number: "BITE/BA/05" ,due_pending:true,otp_verified:true,bio_metric:true},
                { roll_no: "R206", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc  Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06",due_pending:true ,otp_verified:true,bio_metric:true},
                { roll_no: "R207", name: "Student 7", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA  Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R208", name: "Student 8", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Com  Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:false,otp_verified:true,bio_metric:true },
                { roll_no: "R209", name: "Student 9", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A  Semester 1 - SECTION A", student_registration_number: "BITE/BA/09",due_pending:true,otp_verified:true,bio_metric:true },
                { roll_no: "R210", name: "Student 10", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc  Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10" ,due_pending:false,otp_verified:true,bio_metric:true}
            ]
        }
    },

    // ------------------ 3 ------------------
    {
        id: 3,
        activity_name: "Tour Registration — Batch 2",
        auto_generated: "EVENT#3",
        descriptions: "Tour Registration card generates",
        timeline: { start: "2025-04-04", end: "2025-04-08" },
        status: "Active",
        assigned_to: ["Amit"],
        students_summary: [
            { key: "issued", value: "7/10" },
            { key: "paid", value: "6/10" }
        ],
        admit_status_count: { total: 30, success: 16, pending: 14 },
        details: {
            timeline: "4/4/2025 — 4/8/2025",
            assigned_employees: ["Amit"],
            dues_summary: { pending: 5, done: 12,total:17 },
            nocs_summary: { pending: 7, done: 10 ,total:17},
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            selected_students: [
                { roll_no: "R301", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A  Semester 1 - SECTION A", student_registration_number: "BITE/BA/01" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R302", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R303", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03",due_pending:true ,otp_verified:true,bio_metric:true},
                { roll_no: "R304", name: "Student 4", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R305", name: "Student 5", primary_status: "NOC Cleared", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R306", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R307", name: "Student 7", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07",due_pending:true,otp_verified:true,bio_metric:true },
                { roll_no: "R308", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R309", name: "Student 9", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09",due_pending:false,otp_verified:true,bio_metric:true },
                { roll_no: "R310", name: "Student 10", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10" ,due_pending:false,otp_verified:true,bio_metric:true}
            ]
        }
    },

    // ------------------ 4 ------------------
    {
        id: 4,
        activity_name: "Exam Form — Batch 2",
        auto_generated: "EVENT#4",
        descriptions: "Exam Form card generates",
        timeline: { start: "2025-05-05", end: "2025-05-09" },
        status: "active",
        assigned_to: ["Ramesh", "Sita"],
        students_summary: [
            { key: "pass", value: "5/10" },
            { key: "paid", value: "6/10" }
        ],
        admit_status_count: { total: 50, success: 36, pending: 14 },
        details: {
            timeline: "5/5/2025 — 5/9/2025",
            assigned_employees: ["Ramesh", "Sita"],
            dues_summary: { pending: 3, done: 7,total:10 },
            nocs_summary: { pending: 5, done: 5,total:10 },
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            selected_students: [
                { roll_no: "R401", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/01" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R402", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R403", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03" ,due_pending:true,otp_verified:true,bio_metric:true},
                { roll_no: "R404", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit  Card Not Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R405", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R406", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R407", name: "Student 7", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R408", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08" ,due_pending:true,otp_verified:true,bio_metric:true},
                { roll_no: "R409", name: "Student 9", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09",due_pending:false,otp_verified:true,bio_metric:true },
                { roll_no: "R410", name: "Student 10", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10",due_pending:false ,otp_verified:true,bio_metric:true}
            ]
        }
    },

    // ------------------ 5 ------------------
    {
        id: 5,
        activity_name: "Library Card Activation — Batch 3",
        auto_generated: "EVENT#5",
        descriptions: "Library Card generates",
        timeline: { start: "2025-06-01", end: "2025-06-05" },
        status: "closed",
        assigned_to: ["Amit"],
        students_summary: [
            { key: "noc_cleared", value: "6/10" },
            { key: "admit_issued", value: "7/10" }
        ],
        admit_status_count: { total: 60, success: 44, pending: 16 },
        details: {
            timeline: "6/1/2025 — 6/5/2025",
            assigned_employees: ["Amit"],
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            dues_summary: { pending: 1, done: 7 ,total:8},
            nocs_summary: { pending: 2, done: 6 ,total:8},
            selected_students: [
                { roll_no: "R501", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/01" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R502", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R503", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03",due_pending:false,otp_verified:true,bio_metric:true },
                { roll_no: "R504", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R505", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R506", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R507", name: "Student 7", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R508", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:true,otp_verified:true,bio_metric:true },
                { roll_no: "R509", name: "Student 9", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R510", name: "Student 10", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10" ,due_pending:false,otp_verified:true,bio_metric:true}
            ]
        }
    },

    // ------------------ 6 ------------------
    {
        id: 6,
        activity_name: "EVENT#6",
        auto_generated: "Auto-generated activity #6",
        timeline: { start: "2025-07-02", end: "2025-07-06" },
        status: "active",
        assigned_to: ["Sita"],
        descriptions: "Auto-generated Card generates",
        students_summary: [
            { key: "pass", value: "6/10" },
            { key: "paid", value: "7/10" }
        ],
        admit_status_count: { total: 60, success: 50, pending: 10 },
        details: {
            timeline: "7/2/2025 — 7/6/2025",
            assigned_employees: ["Sita"],
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            dues_summary: { pending: 4, done: 11,total:15 },
            nocs_summary: { pending: 5, done: 10,total:15 },
            selected_students: [
                { roll_no: "R601", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/01",due_pending:false },
                { roll_no: "R602", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false },
                { roll_no: "R603", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03" ,due_pending:false},
                { roll_no: "R604", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04",due_pending:false },
                { roll_no: "R605", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05" ,due_pending:false},
                { roll_no: "R606", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06",due_pending:true },
                { roll_no: "R607", name: "Student 7", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07",due_pending:false },
                { roll_no: "R608", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:false },
                { roll_no: "R609", name: "Student 9", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09" ,due_pending:false},
                { roll_no: "R610", name: "Student 10", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10",due_pending:false }
            ]
        }
    },

    // ------------------ 7 ------------------
    {
        id: 7,
        activity_name: "Sports Kit Allocation — Batch 5",
        auto_generated: "EVENT#7",
        timeline: { start: "2025-08-01", end: "2025-08-04" },
        status: "Active",
        assigned_to: ["Amit", "Sita"],
        descriptions: "Sports Kit Allocation Card generates",
        admit_status_count: { total: 70, success: 45, pending: 25 },
        students_summary: [
            { key: "kit_given", value: "6/10" },
            { key: "pending", value: "4/10" }
        ],

        details: {
            timeline: "8/1/2025 — 8/4/2025",
            assigned_employees: ["Amit", "Sita"],
            dues_summary: { pending: 6, done: 9,total:15 },
            nocs_summary: { pending: 8, done: 7,total:15 },
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            selected_students: [
                { roll_no: "R701", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/01",due_pending:false },
                { roll_no: "R702", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false },
                { roll_no: "R703", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03",due_pending:false },
                { roll_no: "R704", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04" ,due_pending:false},
                { roll_no: "R705", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05",due_pending:true },
                { roll_no: "R706", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06" ,due_pending:false},
                { roll_no: "R707", name: "Student 7", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07" ,due_pending:false},
                { roll_no: "R708", name: "Student 8", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:false },
                { roll_no: "R709", name: "Student 9", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09" ,due_pending:true},
                { roll_no: "R710", name: "Student 10", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10" ,due_pending:false}
            ]
        }
    },

    // ------------------ 8 ------------------
    {
        id: 8,
        activity_name: "EVENT#8",
        auto_generated: "Auto-generated activity #8",
        descriptions: "Sports Kit Allocation Card generates",
        timeline: { start: "2025-09-10", end: "2025-09-14" },
        status: "active",
        assigned_to: ["Ramesh"],
        admit_status_count: { total: 10, success: 6, pending: 4 },
        students_summary: [
            { key: "checked", value: "9/10" },
            { key: "pending", value: "1/10" }
        ],

        details: {
            timeline: "9/10/2025 — 9/14/2025",
            assigned_employees: ["Ramesh"],
            dues_summary: { pending: 3, done: 7 ,total:10},
            nocs_summary: { pending: 5, done: 5 ,total:10},
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            selected_students: [
                { roll_no: "R801", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/01",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R802", name: "Student 2", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02",due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R803", name: "Student 3", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R804", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04" ,due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R805", name: "Student 5", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05" ,due_pending:true,otp_verified:true,bio_metric:true},
                { roll_no: "R806", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06" ,due_pending:false,otp_verified:true,bio_metric:true},
                { roll_no: "R807", name: "Student 7", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R808", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:false,otp_verified:true,bio_metric:true },
                { roll_no: "R809", name: "Student 9", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09",due_pending:false ,otp_verified:true,bio_metric:true},
                { roll_no: "R810", name: "Student 10", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10",due_pending:false ,otp_verified:true,bio_metric:true}
            ]
        }
    },

    // ------------------ 9 ------------------
    {
        id: 9,
        activity_name: "Bus Pass Renewal — Batch 7",
        auto_generated: "EVENT#9",
        descriptions: "Bus Pass Renewal Card generates",
        timeline: { start: "2025-10-05", end: "2025-10-09" },
        status: "closed",
        assigned_to: ["Amit"],
        admit_status_count: { total: 70, success: 46, pending: 24 },
        students_summary: [
            { key: "renewed", value: "8/10" },
            { key: "pending", value: "2/10" }
        ],

        details: {
            timeline: "10/5/2025 — 10/9/2025",
            assigned_employees: ["Amit"],
            dues_summary: { pending: 3, done: 15 ,total:18},
            nocs_summary: { pending: 5, done: 13,total:18 },
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            selected_students: [
                { roll_no: "R901", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/01",due_pending:false },
                { roll_no: "R902", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/02" ,due_pending:true},
                { roll_no: "R903", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/03",due_pending:false },
                { roll_no: "R904", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/04" ,due_pending:false},
                { roll_no: "R905", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/05",due_pending:false },
                { roll_no: "R906", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/06",due_pending:false },
                { roll_no: "R907", name: "Student 7", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA Semester 1 - SECTION A", student_registration_number: "BITE/BCA/07" ,due_pending:false},
                { roll_no: "R908", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com Semester 1 - SECTION A", student_registration_number: "BITE/BCOM/08",due_pending:false },
                { roll_no: "R909", name: "Student 9", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A Semester 1 - SECTION A", student_registration_number: "BITE/BA/09" ,due_pending:false},
                { roll_no: "R910", name: "Student 10", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc Semester 1 - SECTION A", student_registration_number: "BITE/BSC/10",due_pending:false }
            ]
        }
    },

    // ------------------ 10 ------------------
    {
        id: 10,
        activity_name: "Graduation Ceremony — Batch 8",
        descriptions: "Graduation Ceremony Card generates",
        auto_generated: "EVENT#10",
        timeline: { start: "2025-11-01", end: "2025-11-05" },
        status: "active",
        assigned_to: ["Ramesh", "Sita"],
        students_summary: [
            { key: "gown_issued", value: "9/10" },
            { key: "paid", value: "8/10" }
        ],
        admit_status_count: { total: 50, success: 36, pending: 14 },
        details: {
            timeline: "11/1/2025 — 11/5/2025",
            assigned_employees: ["Ramesh", "Sita"],
            dues_summary: { pending: 2, done: 8,total:10 },
            nocs_summary: { pending: 5, done: 5,total:10},
            prechecks_summary: { pending: 10, success: 10, total: 20 },
            selected_students: [
                { roll_no: "R1001", name: "Student 1", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.A", student_registration_number: "BITE/BA/01",due_pending:false },
                { roll_no: "R1002", name: "Student 2", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.Sc", student_registration_number: "BITE/BSC/02" ,due_pending:false},
                { roll_no: "R1003", name: "Student 3", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA", student_registration_number: "BITE/BCA/03" ,due_pending:false},
                { roll_no: "R1004", name: "Student 4", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com", student_registration_number: "BITE/BCOM/04",due_pending:true },
                { roll_no: "R1005", name: "Student 5", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A", student_registration_number: "BITE/BA/05",due_pending:true },
                { roll_no: "R1006", name: "Student 6", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc", student_registration_number: "BITE/BSC/06" ,due_pending:true},
                { roll_no: "R1007", name: "Student 7", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.CA", student_registration_number: "BITE/BCA/07",due_pending:true },
                { roll_no: "R1008", name: "Student 8", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Com", student_registration_number: "BITE/BCOM/08" ,due_pending:true},
                { roll_no: "R1009", name: "Student 9", primary_status: "NOC Pending", secondary_status: "Admit  Card Not Issued", course: "B.A", student_registration_number: "BITE/BA/09" ,due_pending:true},
                { roll_no: "R1010", name: "Student 10", primary_status: "NOC Cleared", secondary_status: "Admit Card Issued", course: "B.Sc", student_registration_number: "BITE/BSC/10" ,due_pending:true}
            ]
        }
    }
];



export const dummyStudentActivityData = [
  {
    student_id: 1,
    student_name: "Aman Kumar",
    registration_no: "BA/2024/250",
    activities: [
      {
        id: 5,
        activity_name: "Admit Card BA Sem III",
        start_date: "2025-12-01",
        end_date: "2025-12-20",
        exam_start_date: "2025-12-05"
      },
      {
        id: 6,
        activity_name: "Admit Card BA Sem V",
        start_date: "2025-12-01",
        end_date: "2025-12-22",
        exam_start_date: "2025-12-10"
      },
      {
        id: 7,
        activity_name: "Admit Card BA Sem VI",
        start_date: "2025-12-05",
        end_date: "2025-12-25",
        exam_start_date: "2025-12-15"
      }
    ]
  },
  {
    student_id: 2,
    student_name: "Rahul Sharma",
    registration_no: "BA/2024/49",
    activities: [
      {
        id: 204,
        activity_name: "Admit Card BSc Sem III",
        start_date: "2025-12-02",
        end_date: "2025-12-18",
        exam_start_date: "2025-12-06"
      },
      {
        id: 205,
        activity_name: "Admit Card BSc Sem V",
        start_date: "2025-12-04",
        end_date: "2025-12-21",
        exam_start_date: "2025-12-12"
      }
    ]
  },
  {
    student_id: 3,
    student_name: "Priya Singh",
    registration_no: "BA/2024/06",
    activities: [
      {
        id: 206,
        activity_name: "Admit Card BCom Sem III",
        start_date: "2025-12-03",
        end_date: "2025-12-17",
        exam_start_date: "2025-12-07"
      }
    ]
  },
  {
    student_id: 4,
    student_name: "Neha Verma",
    registration_no: "BA/2024/150",
    activities: [
      {
        id: 207,
        activity_name: "Admit Card MA History Sem III",
        start_date: "2025-12-01",
        end_date: "2025-12-19",
        exam_start_date: "2025-12-08"
      },
      {
        id: 208,
        activity_name: "Admit Card MA History Sem IV",
        start_date: "2025-12-06",
        end_date: "2025-12-22",
        exam_start_date: "2025-12-14"
      },
      {
        id: 209,
        activity_name: "Admit Card MA History Sem V",
        start_date: "2025-12-10",
        end_date: "2025-12-28",
        exam_start_date: "2025-12-20"
      }
    ]
  },
  {
    student_id: 5,
    student_name: "Rohit Yadav",
    registration_no: "BA/2024/78",
    activities: [
      {
        id: 210,
        activity_name: "Admit Card BCA Sem III",
        start_date: "2025-12-02",
        end_date: "2025-12-18",
        exam_start_date: "2025-12-09"
      },
      {
        id: 211,
        activity_name: "Admit Card BCA Sem V",
        start_date: "2025-12-05",
        end_date: "2025-12-23",
        exam_start_date: "2025-12-16"
      }
    ]
  },
  {
    student_id: 6,
    student_name: "Anjali Mishra",
    registration_no: "BA/2024/47",
    activities: [
      {
        id: 212,
        activity_name: "Admit Card MCom Sem I",
        start_date: "2025-12-04",
        end_date: "2025-12-15",
        exam_start_date: "2025-12-10"
      }
    ]
  },
  {
    student_id: 7,
    student_name: "Vikas Patel",
    registration_no: "BA/2024/44",
    activities: [
      {
        id: 213,
        activity_name: "Admit Card MSc Physics Sem II",
        start_date: "2025-12-01",
        end_date: "2025-12-20",
        exam_start_date: "2025-12-11"
      },
      {
        id: 214,
        activity_name: "Admit Card MSc Physics Sem III",
        start_date: "2025-12-06",
        end_date: "2025-12-24",
        exam_start_date: "2025-12-17"
      },
      {
        id: 215,
        activity_name: "Admit Card MSc Physics Sem IV",
        start_date: "2025-12-10",
        end_date: "2025-12-30",
        exam_start_date: "2025-12-22"
      }
    ]
  },
  {
    student_id: 8,
    student_name: "Pooja Gupta",
    registration_no: "BA/2024/182",
    activities: [
      {
        id: 216,
        activity_name: "Admit Card BA Sem I",
        start_date: "2025-12-02",
        end_date: "2025-12-14",
        exam_start_date: "2025-12-06"
      }
    ]
  },
  {
    student_id: 9,
    student_name: "Sandeep Kumar",
    registration_no: "BA/2024/200",
    activities: [
      {
        id: 217,
        activity_name: "Admit Card BSc Sem I",
        start_date: "2025-12-03",
        end_date: "2025-12-16",
        exam_start_date: "2025-12-07"
      },
      {
        id: 218,
        activity_name: "Admit Card BSc Sem II",
        start_date: "2025-12-08",
        end_date: "2025-12-22",
        exam_start_date: "2025-12-14"
      }
    ]
  },
  {
    student_id: 10,
    student_name: "Kavita Singh",
    registration_no: "BA/2024/248",
    activities: [
      {
        id: 219,
        activity_name: "Admit Card MA Sociology Sem III",
        start_date: "2025-12-05",
        end_date: "2025-12-18",
        exam_start_date: "2025-12-12"
      }
    ]
  }
];
